<script>
import { ref, watch, onBeforeUnmount } from 'vue'

export default function useServerTable(initial = {}) {
    const q = ref(initial.q ?? '')
    const page = ref(initial.page ?? 1)
    const perPage = ref(initial.perPage ?? 10)
    const sortBy = ref(initial.sortBy ?? 'id')
    const sortDir = ref(initial.sortDir ?? 'asc')

    // debounce simple para q — sin immediate para evitar doble request inicial
    let t
    const qDebounced = ref(q.value)
    watch(q, (val) => {
        clearTimeout(t)
        t = setTimeout(() => {
            qDebounced.value = val
            page.value = 1 // reset page al buscar
        }, 300)
    })

    onBeforeUnmount(() => clearTimeout(t))

    // exponemos qDebounced como q (para consumidores)
    return {
        q: qDebounced,
        page,
        perPage,
        sortBy,
        sortDir
    }
}
</script>
